import React from 'react'
import style from  '../../Styles/Footer/Footer.module.css'

const Footer = () => {
  return (
    <div className={style.primaryFooter}>
        <p>&copy; 2025  BEETECH All rights reserved.</p>
    </div>
  )
}

export default Footer